import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 15v-6l4 6v-6","key":"svg-1"}]]

const IconMapNorth = createReactComponent('outline', 'map-north', 'MapNorth', __iconNode);

export default IconMapNorth;